import map from 'lodash/map';
import first from 'lodash/first';
import includes from 'lodash/includes';

export const isVowel = (char)=>
  includes(['a', 'e', 'i', 'o', 'u'], char.toLowerCase());

export const startsWithVowel = (strn)=>
  isVowel(first(strn.split('')));

export const toTitleCase = (str)=> {
  return map(str.toLowerCase().split(' '), (word)=> {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
};
